import Alert from "@mui/material/Alert";
import Paper from "@mui/material/Paper";
import React from "react";
import { useAppSelector } from "@store/hooks";

const name = "News"

const News: React.FC = () => {
    const news = useAppSelector(({ state }) => state.News)

    return (<Paper elevation={4} sx={{ mb: 1, mt: -1 }}>
        <Alert variant="outlined" severity="warning" sx={{ fontSize: "1.1rem", fontWeight: "bold" }}>Latest: {news}</Alert>
    </Paper>
    )
}

News.displayName = name;

export default React.memo(News);